import React from "react";
import { motion } from "framer-motion";

import Deliver from "../assets/process/undraw_deliveries_qutl.svg";
import Metrics from "../assets/process/undraw_metrics_5v8d.svg";
import Programmer from "../assets/process/undraw_programmer_raqr.svg";
import Design from "../assets/process/undraw_web-design-showcase_6t2l.svg";
import Report from "../assets/process/undraw_report_k55w.svg";
import Survey from "../assets/process/undraw_online-survey_xq2g.svg";

const steps = [
  {
    src: Survey,
    label: "Ideation",
    desc: "Brainstorm and validate your idea together.",
  },
  {
    src: Design,
    label: "Design",
    desc: "Craft user-centric designs and prototypes.",
  },
  {
    src: Programmer,
    label: "Development",
    desc: "Build, test, and launch your product.",
  },
  {
    src: Report,
    label: "Maintenance",
    desc: "Provide ongoing support and improvements.",
  },
  {
    src: Metrics,
    label: "Consulting",
    desc: "Offer expert advice to optimize your project.",
  },
  {
    src: Deliver,
    label: "Scaling",
    desc: "Help grow your product to meet increasing demand.",
  },
];

const Whyme = () => (
  <div className="max-w-[1240px] text-white min-h-[1080px] mx-auto flex flex-col justify-center" id="whyme">
    <div className="mx-auto grid md:grid-cols-2 py-16 px-4">
      <motion.h1
        className={`text-3xl md:text-4xl font-extrabold mb-6 max-w-[1240px] text-[#00df9a]`}
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        style={{ fontFamily: "'Montserrat', sans-serif" }}
      >
        Leverage expertise, scale efficiently, and accelerate your project's success with my comprehensive services.
      </motion.h1>
    </div>
    <div className="w-full flex justify-center relative">
      {/* Scroll hint arrow on the right */}
      <div className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 z-10 hidden md:block">
        <div className="flex flex-col items-center animate-bounce">
          <svg width="32" height="32" fill="none" viewBox="0 0 24 24">
            <path d="M8 5l8 7-8 7" stroke="#00df9a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span className="text-xs text-[#00df9a] mt-1">scroll</span>
        </div>
      </div>
      <div className="w-full overflow-x-auto scrollbar-thin scrollbar-thumb-[#00df9a]/60 scrollbar-track-gray-900/20 pr-8">
        <div className="flex flex-row items-center justify-start gap-8 py-8 min-w-[900px]">
          {steps.map((step, i) => (
            <React.Fragment key={i}>
              <motion.div
                className="flex flex-col items-center bg-white rounded-2xl shadow-md p-6 min-w-[180px] mx-2"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.3 + i * 0.2 }}
                whileHover={{ scale: 1.08 }}
              >
                <img src={step.src} alt={step.label} className="w-50 h-40 mb-3" />
                <h3 className="text-xl font-semibold text-gray-900 mb-1">
                  {step.label}
                </h3>
                <p className="text-gray-600 text-center text-sm">{step.desc}</p>
              </motion.div>
              {i < steps.length - 1 && (
                <span className="mx-2 text-4xl text-gray-400 hidden md:inline-block">→</span>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default Whyme;